<template>
    <div>
    <div class="py-3"></div>
    
    <v-card
        class="mx-auto"
        max-width="90%"
    >
    <v-toolbar
        :color="'light-blue darken-3'"
        dark
    >    
    <v-toolbar-title>이미지 퀴즈 그룹관리</v-toolbar-title>
        <v-spacer/>
        <v-btn
            color="cyan"
            small
            fab
            @click="ShowDialog_CreateBundle"
        >
            <v-icon 
            color= "white"
            >mdi-plus</v-icon>
        </v-btn>
    </v-toolbar>
    <v-list>
        <v-data-table         
        :footer-props="{'items-per-page-options':[20, 50, -1], 'items-per-page': 50}"
        :headers="headers" 
        :items="quiz_group_list"
        :loading="loadingData"
        >        
        <template v-slot:item="row">            
            <tr>
            <td>{{row.item.pid}}</td>
            <td>{{row.item.title}}</td>
            <!-- <td>{{row.item.level}}</td> -->
          
            <td>{{row.item.comment}}</td>
            <td :style="{ color: row.item.quiz_count === 0 ? 'red' : 'black' }">
                {{ row.item.count }}
            </td>
            <td>
                <div v-if="getQuizTypeThumbnail(row.item.quiz_type)" class="d-flex align-center">
                    <v-img
                        :src="getQuizTypeThumbnail(row.item.quiz_type)"
                        max-width="40"
                        max-height="40"
                        contain
                        class="mr-2"
                    ></v-img>
                    <span>{{getQuizTypeLabel(row.item.quiz_type)}}</span>
                </div>
                <span v-else>{{getQuizTypeLabel(row.item.quiz_type)}}</span>
            </td>
            <td>
                <span :style="{ color: getIsInitialized(row.item) ? 'blue' : 'red', fontWeight: 'bold' }">
                    {{ getIsInitialized(row.item) ? '초기화됨' : '미초기화' }}
                </span>
            </td>
            <td>
                <v-btn width="120px"
                color="indigo"
                class='white--text'
                @click="OnClickEdit_Item(row.item)">편집하기</v-btn>
            </td>
            <!-- <td>
                <v-switch
                    v-model="row.item.active"
                    inset       
                    @change="Save_Change_ActiveState(row.item)"
                ></v-switch>
            </td>
             -->
            </tr>
        </template>
        </v-data-table>
    </v-list>
    </v-card>
   
  <template>
<template>
 <v-dialog v-model="dialog" max-width="900">
  <v-card>
    <v-card-title class="text-h5">퀴즈 문제 설정</v-card-title>

    <v-card-text>

      <!-- 이미지/타일 퀴즈: 카테고리 선택 방식 -->
      <template v-if="isCategoryBasedType(current_group_type)">
        <!-- ✅ 문제 선택 버튼 -->
        <div class="mb-5">
          <label class="text-subtitle-1 font-weight-bold">문제 선택</label>
          <v-row dense>
            <v-col
              v-for="(q, index) in groupCount"
              :key="index"
              cols="auto"
            >
              <v-btn
                :color="selectedQuestionIndex === index ? 'primary' : 'grey lighten-2'"
                depressed
                @click="selectedQuestionIndex = index"
              >
                {{ index + 1 }}번
              </v-btn>
            </v-col>
          </v-row>
        </div>

        <!-- ✅ 카테고리 선택 영역 -->
        <div class="pa-4 mb-4" style="border-radius: 12px; background-color: #f3f0fb;">
          <label class="text-subtitle-1 font-weight-bold mb-2 d-block">카테고리 선택</label>
         <v-chip-group
          :key="'chip-group-' + selectedQuestionIndex"
          multiple
          column
          >
              <v-chip
                  v-for="category in category_list"
                  :key="category.pid + '-' + selectedQuestionIndex"
                  :color="isCategorySelected(selectedQuestionIndex, category.pid) ? 'indigo darken-2' : 'indigo lighten-4'"
                  :text-color="isCategorySelected(selectedQuestionIndex, category.pid) ? 'white' : 'black'"
                  class="ma-1"
                  @click="toggleCategory(selectedQuestionIndex, category.pid)"
                  >
                  {{ category.category_comment }}
                  </v-chip>
          </v-chip-group>
        </div>
      </template>

      <!-- 기억력 퀴즈/색깔 퀴즈: 단계별 설정 -->
      <template v-else-if="current_group_type === 'MEMORY' || current_group_type === 'COLOR'">
        <!-- 단계 수 설정 영역 -->
        <div class="pa-4 mb-4" style="border-radius: 12px; background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);">
          <v-row dense align="center">
            <v-col cols="12" md="4" class="d-flex align-center">
              <v-icon color="white" class="mr-2">mdi-stairs</v-icon>
              <span class="text-subtitle-1 font-weight-bold white--text">단계 수 설정</span>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model.number="memory_stage_count"
                type="number"
                min="1"
                max="10"
                outlined
                dense
                hide-details
                background-color="white"
                color="purple darken-2"
                @input="updateMemoryStageMap"
              />
            </v-col>
            <v-col cols="12" md="4" class="text-right">
              <v-chip small color="white" text-color="purple darken-2">
                총 {{ memory_stage_count }}단계
              </v-chip>
            </v-col>
          </v-row>
        </div>

        <!-- 단계별 설정 영역 -->
        <div class="mb-4">
          <div class="d-flex align-center mb-3">
            <v-icon color="indigo darken-2" class="mr-2">mdi-format-list-numbered</v-icon>
            <label class="text-subtitle-1 font-weight-bold">단계별 설정</label>
          </div>
          
          <v-card outlined style="border-radius: 12px; overflow: hidden;">
            <v-card-text class="pa-0">
              <v-list>
                <v-list-item 
                  v-for="(stage, index) in memory_stage_map"
                  :key="'memory-stage-' + index"
                  :class="{'mb-1': index < memory_stage_map.length - 1}"
                  style="border-bottom: 1px solid #e0e0e0;"
                >
                  <v-list-item-avatar 
                    color="purple lighten-3"
                    size="40"
                    class="mr-3"
                  >
                    <span class="purple--text text--darken-2 font-weight-bold">{{ stage.stage }}</span>
                  </v-list-item-avatar>
                  
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium mb-2">
                      {{ stage.stage }}단계 설정
                    </v-list-item-title>
                    <v-row dense>
                      <v-col cols="12" md="3">
                        <v-select
                          v-model="stage.tileSize"
                          :items="tile_size_options"
                          item-text="label"
                          item-value="value"
                          label="타일 크기"
                          outlined
                          dense
                          hide-details
                          prepend-inner-icon="mdi-grid"
                          :color="getTileSizeColor(stage.tileSize)"
                        >
                          <template v-slot:selection="{ item }">
                            <div class="d-flex align-center">
                              <v-chip
                                x-small
                                :color="getTileSizeColor(item.value)"
                                text-color="white"
                                class="mr-2 font-weight-bold"
                              >
                                {{ getTileSizeDifficulty(item.value) }}
                              </v-chip>
                              <span>{{ item.label }}</span>
                            </div>
                          </template>
                          <template v-slot:item="{ item }">
                            <v-list-item-content>
                              <v-list-item-title>
                                <div class="d-flex align-center">
                                  <v-chip
                                    x-small
                                    :color="getTileSizeColor(item.value)"
                                    text-color="white"
                                    class="mr-2 font-weight-bold"
                                  >
                                    {{ getTileSizeDifficulty(item.value) }}
                                  </v-chip>
                                  <span>{{ item.label }}</span>
                                </div>
                              </v-list-item-title>
                            </v-list-item-content>
                          </template>
                        </v-select>
                        <!-- 난이도 표시 칩 -->
                        <div class="mt-1">
                          <v-chip
                            x-small
                            :color="getTileSizeColor(stage.tileSize)"
                            text-color="white"
                            class="font-weight-bold"
                          >
                            <v-icon x-small left>{{ getTileSizeIcon(stage.tileSize) }}</v-icon>
                            {{ getTileSizeDifficulty(stage.tileSize) }}
                          </v-chip>
                        </div>
                      </v-col>
                      <v-col cols="12" md="3">
                        <!-- 기억력 퀴즈: 기억 타일 수 -->
                        <v-text-field
                          v-if="current_group_type === 'MEMORY'"
                          v-model.number="stage.memoryCount"
                          type="number"
                          min="1"
                          :max="stage.tileSize * stage.tileSize"
                          label="기억 타일 수"
                          outlined
                          dense
                          hide-details
                          prepend-inner-icon="mdi-numeric"
                          hint="타일 크기의 제곱 이하로 설정"
                          persistent-hint
                        />
                        <!-- 색깔 퀴즈: 난이도 (1~10) -->
                        <v-text-field
                          v-else-if="current_group_type === 'COLOR'"
                          v-model.number="stage.difficulty"
                          type="number"
                          min="1"
                          max="10"
                          label="난이도 (1~10)"
                          outlined
                          dense
                          hide-details
                          prepend-inner-icon="mdi-star"
                          hint="1: 쉬움, 10: 매우 어려움 (거의 차이 없음)"
                          persistent-hint
                        />
                      </v-col>
                      <v-col cols="12" md="3">
                        <v-text-field
                          v-model.number="stage.timeLimit"
                          type="number"
                          min="1"
                          label="퀴즈 풀 시간 (초)"
                          outlined
                          dense
                          hide-details
                          prepend-inner-icon="mdi-timer"
                        />
                      </v-col>
                      <v-col cols="12" md="3">
                        <v-text-field
                          v-model.number="stage.penaltyTime"
                          type="number"
                          min="0"
                          label="틀렸을 때 감점 시간 (초)"
                          outlined
                          dense
                          hide-details
                          prepend-inner-icon="mdi-timer-off"
                        />
                      </v-col>
                    </v-row>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card-text>
          </v-card>
        </div>
      </template>

      <!-- 오십까지 퀴즈: 문제 갯수, 전체 게임 시간, 차감 시간 설정 -->
      <template v-else-if="current_group_type === 'FIFTY'">
        <div class="pa-4 mb-4" style="border-radius: 12px; background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);">
          <v-row dense align="center" class="mb-4">
            <v-col cols="12" md="4" class="d-flex align-center">
              <v-icon color="white" class="mr-2">mdi-numeric</v-icon>
              <span class="text-subtitle-1 font-weight-bold white--text">문제 갯수</span>
            </v-col>
            <v-col cols="12" md="8">
              <v-text-field
                v-model.number="fifty_question_count"
                type="number"
                min="1"
                outlined
                dense
                hide-details
                background-color="white"
                color="pink darken-2"
                prepend-inner-icon="mdi-help-circle"
              />
            </v-col>
          </v-row>
          
          <v-row dense align="center" class="mb-4">
            <v-col cols="12" md="4" class="d-flex align-center">
              <v-icon color="white" class="mr-2">mdi-timer</v-icon>
              <span class="text-subtitle-1 font-weight-bold white--text">전체 게임 시간 (초)</span>
            </v-col>
            <v-col cols="12" md="8">
              <v-text-field
                v-model.number="fifty_timeLimit"
                type="number"
                min="1"
                outlined
                dense
                hide-details
                background-color="white"
                color="pink darken-2"
                prepend-inner-icon="mdi-clock-outline"
              />
            </v-col>
          </v-row>
          
          <v-row dense align="center">
            <v-col cols="12" md="4" class="d-flex align-center">
              <v-icon color="white" class="mr-2">mdi-timer-off</v-icon>
              <span class="text-subtitle-1 font-weight-bold white--text">틀렸을 때 차감 시간 (초)</span>
            </v-col>
            <v-col cols="12" md="8">
              <v-text-field
                v-model.number="fifty_penalty_time"
                type="number"
                min="0"
                outlined
                dense
                hide-details
                background-color="white"
                color="pink darken-2"
                prepend-inner-icon="mdi-minus-circle"
              />
            </v-col>
          </v-row>
        </div>
      </template>

      <!-- DRAWING/NONSENSE: 문제 수 설정 + 문제별 제한시간 설정 -->
      <template v-else-if="isLevelBasedType(current_group_type) && (current_group_type === 'DRAWING' || current_group_type === 'NONSENSE')">
        <!-- 문제 수 설정 영역 -->
        <div class="pa-4 mb-4" style="border-radius: 12px; background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);">
          <v-row dense align="center">
            <v-col cols="12" md="4" class="d-flex align-center">
              <v-icon color="white" class="mr-2">mdi-numeric</v-icon>
              <span class="text-subtitle-1 font-weight-bold white--text">문제 수 설정</span>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model.number="groupCount"
                type="number"
                min="1"
                outlined
                dense
                hide-details
                background-color="white"
                color="purple darken-2"
                @input="updateQuestionTimeMap"
              />
            </v-col>
            <v-col cols="12" md="4" class="text-right">
              <v-chip small color="white" text-color="purple darken-2">
                총 {{ groupCount }}개 문제
              </v-chip>
            </v-col>
          </v-row>
        </div>

        <!-- 문제별 제한시간 설정 영역 -->
        <div class="mb-4">
          <div class="d-flex align-center mb-3">
            <v-icon color="purple darken-2" class="mr-2">mdi-timer-outline</v-icon>
            <label class="text-subtitle-1 font-weight-bold">문제별 제한시간 설정 (초)</label>
          </div>
          
          <v-card outlined style="border-radius: 12px; overflow: hidden;">
            <v-card-text class="pa-0">
              <v-list>
                <v-list-item 
                  v-for="(timeItem, index) in question_time_map"
                  :key="'time-' + index"
                  :class="{'mb-1': index < question_time_map.length - 1}"
                  style="border-bottom: 1px solid #e0e0e0;"
                >
                  <v-list-item-avatar 
                    color="purple lighten-3"
                    size="40"
                    class="mr-3"
                  >
                    <span class="purple--text text--darken-2 font-weight-bold">{{ index + 1 }}</span>
                  </v-list-item-avatar>
                  
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium mb-2">
                      {{ index + 1 }}번 문제
                    </v-list-item-title>
                    <v-text-field
                      v-model.number="timeItem.timeLimit"
                      type="number"
                      min="1"
                      label="제한시간 (초)"
                      outlined
                      dense
                      hide-details
                      prepend-inner-icon="mdi-timer"
                      style="max-width: 200px;"
                    />
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card-text>
          </v-card>
        </div>
      </template>

      <!-- 가로세로/4지선답 퀴즈: 문제 갯수 설정 + 레벨 선택 -->
      <template v-else-if="isLevelBasedType(current_group_type) && current_group_type !== 'MEMORY' && current_group_type !== 'COLOR' && current_group_type !== 'FIFTY' && current_group_type !== 'DRAWING' && current_group_type !== 'NONSENSE'">
        <!-- 문제 수 설정 영역 -->
        <div class="pa-4 mb-4" style="border-radius: 12px; background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);">
          <v-row dense align="center">
            <v-col cols="12" md="4" class="d-flex align-center">
              <v-icon color="white" class="mr-2">mdi-numeric</v-icon>
              <span class="text-subtitle-1 font-weight-bold white--text">문제 수 설정</span>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model.number="groupCount"
                type="number"
                min="1"
                outlined
                dense
                hide-details
                background-color="white"
                color="purple darken-2"
                @input="updateQuestionLevelMap"
              />
            </v-col>
            <v-col cols="12" md="4" class="text-right">
              <v-chip small color="white" text-color="purple darken-2">
                총 {{ groupCount }}개 문제
              </v-chip>
            </v-col>
          </v-row>
        </div>

        <!-- 문제별 레벨 설정 영역 -->
        <div class="mb-4">
          <div class="d-flex align-center mb-3">
            <v-icon color="indigo darken-2" class="mr-2">mdi-format-list-numbered</v-icon>
            <label class="text-subtitle-1 font-weight-bold">문제별 레벨 설정</label>
          </div>
          
          <v-card outlined style="border-radius: 12px; overflow: hidden;">
            <v-card-text class="pa-0">
              <v-list>
                <v-list-item 
                  v-for="(item, index) in question_level_map"
                  :key="'level-' + index"
                  :class="{'mb-1': index < question_level_map.length - 1}"
                  style="border-bottom: 1px solid #e0e0e0;"
                >
                  <v-list-item-avatar 
                    color="grey lighten-3"
                    size="40"
                    class="mr-3"
                  >
                    <span class="grey--text text--darken-2 font-weight-bold">{{ index + 1 }}</span>
                  </v-list-item-avatar>
                  
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium mb-2">
                      {{ index + 1 }}번 문제
                    </v-list-item-title>
                    <v-row dense>
                      <v-col cols="12" md="6">
                        <v-select
                          v-model="item.level"
                          :items="level_options"
                          item-text="label"
                          item-value="value"
                          label="레벨"
                          outlined
                          dense
                          hide-details
                          :color="getLevelColor(item.level)"
                        >
                          <template v-slot:selection="{ item }">
                            <v-chip
                              small
                              :color="getLevelColor(item.value)"
                              text-color="white"
                              class="font-weight-bold"
                            >
                              {{ item.label }}
                            </v-chip>
                          </template>
                          <template v-slot:item="{ item }">
                            <v-list-item-content>
                              <v-list-item-title>
                                <v-chip
                                  small
                                  :color="getLevelColor(item.value)"
                                  text-color="white"
                                  class="font-weight-bold"
                                >
                                  {{ item.label }}
                                </v-chip>
                              </v-list-item-title>
                            </v-list-item-content>
                          </template>
                        </v-select>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-text-field
                          v-model.number="item.timeLimit"
                          type="number"
                          min="1"
                          label="제한시간 (초)"
                          outlined
                          dense
                          hide-details
                          prepend-inner-icon="mdi-timer"
                        />
                      </v-col>
                    </v-row>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card-text>
          </v-card>
        </div>
      </template>

    </v-card-text>

    <v-card-actions>
      <v-spacer />
      <v-btn text @click="CancelEdit">취소</v-btn>
      <v-btn color="primary" @click="SaveGroupitem">저장</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

  <v-dialog v-model="dialog2" max-width="600">
  <v-card>
    <v-card-title class="text-h5">퀴즈 그룹 생성</v-card-title>
<v-card-text>

  <!-- 🔷 그룹 정보 입력 -->
  <div class="mb-4">
    <v-row dense align="center" class="mb-2">
      <v-col cols="12" md="3" class="text-right pr-4">
        <span class="text-subtitle-2 font-weight-bold">그룹 이름</span>
      </v-col>
      <v-col cols="12" md="9">
        <v-text-field
          v-model="group_title_text"
          placeholder="예: 스냅퀴즈 쉬운문제타입 그룹"
          outlined
          dense
          hide-details
        />
      </v-col>
    </v-row>

    <v-row dense align="center" class="mb-2">
      <v-col cols="12" md="3" class="text-right pr-4">
        <span class="text-subtitle-2 font-weight-bold">그룹 설명</span>
      </v-col>
      <v-col cols="12" md="9">
        <v-text-field
          v-model="group_comment_text"
          placeholder="이 그룹에 대한 간단한 설명"
          outlined
          dense
          hide-details
        />
      </v-col>
    </v-row>

    <v-row dense align="center" class="mb-2">
      <v-col cols="12" md="3" class="text-right pr-4">
        <span class="text-subtitle-2 font-weight-bold">문제 수</span>
      </v-col>
      <v-col cols="12" md="3">
        <v-text-field
          v-model.number="group_quiz_count"
          type="number"
          min="1"
          outlined
          dense
          hide-details
        />
      </v-col>
    </v-row>

    <v-row dense align="center">
      <v-col cols="12" md="3" class="text-right pr-4">
        <span class="text-subtitle-2 font-weight-bold">타입</span>
      </v-col>
      <v-col cols="12" md="9">
        <v-select
          v-model="selected_quiz_type"
          :items="quizTypeOptions"
          item-text="label"
          item-value="value"
          placeholder="타입을 선택하세요"
          outlined
          dense
          hide-details
        />
      </v-col>
    </v-row>
  </div>

  <!-- 🔶 문제 선택 영역 (여기에 추가 예정) -->

</v-card-text>

    <v-card-actions>
      <v-spacer />
      <v-btn text @click="CancelEdit">취소</v-btn>
      <v-btn color="primary" @click="CreateQuizBundle">저장</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

</template>

    </div>

</template>

<script>
import { mapActions } from 'vuex';
import moment from 'moment'
import store from '../../store';
import config from '../../config/config';
import { getQuizListGroupTypeOptions, getQuizTypeLabel, getQuizTypeThumbnail, isCategoryBasedType as checkIsCategoryBasedType, isLevelBasedType as checkIsLevelBasedType } from '../../config/quiz_types';
const { s3_upload , FileUpload_Async, FileUpload_JSON} = require("../../util/fileutil");
import { format, parseISO } from 'date-fns'
// const quiz_level_list = ref([
//         { pid: 1, category: '레벨 1' },
//         { pid: 2, category: '레벨 2' },
//         { pid: 3, category: '레벨 3' },
//         { pid: 4, category: '레벨 4' },
//         { pid: 5, category: '레벨 5' },
//         ]);

export default {
    name: 'UserList',

    data: () => ({
        dialog_title_text :'',
        dialog : false,
        dialog2 : false,
        loadingData:false,        
        create_date:'',
        group_title_text : '',
        group_comment_text: '',
        group_quiz_count: 5,
        selected_quiz_type: 'IMG',
        
        // 퀴즈 타입 옵션 (config에서 가져오기)
        quizTypeOptions: getQuizListGroupTypeOptions(),

        headers: [            
            { text: '고유번호', value: 'pid' },
            { text: '타이틀', value: 'category' },  
            { text: '부가설명', value: 'admin_user' },
            { text: '퀴즈갯수', value: 'create_dt' },
            { text: '퀴즈타입', value: 'quiz_type' },
            { text: '활성정보', value: 'dt_create' },
            { text: '편집하기', value: 'edit' },
            // { text: '등록하기', value: 'dt_export' },
        ],

        quiz_group_list:[],
        category_list:[],

        quiz_group_items:[],
        questionCategoryMap: [], // 가공된 [문제별] → [활성화된 카테고리 id 리스트]

        //그룹 리스트 생성하기 - 일반 API
        //그룹 리스트 가져오기 
        //그룹 리스트 설정 변경하기 
        //선택된 그룹 리스트의 아이템 리스트 정보 가져오기 
        //퀴즈 카테고리 리스트 함께 가져오기 
        //그룹 리스트에 아이템 리스트 설정하기 - JSON으로 저장 불러오기 하기 
        
        
      
        
        selected_main_item_pid:0,

        selected_editing_item:{},
        groupCount:0,
        current_group_type: 'DEFAULT', // 현재 편집 중인 그룹의 타입

        // 4지선답/가로세로 타입용: 문제별 레벨 정보
        question_level_map: [], // [{index: 0, level: 1, timeLimit: 15}, {index: 1, level: 2, timeLimit: 15}, ...]
        level_options: [
            { label: '레벨 1', value: 1 },
            { label: '레벨 2', value: 2 },
            { label: '레벨 3', value: 3 }
        ],
        
        // DRAWING/NONSENSE 타입용: 문제별 제한시간 정보
        question_time_map: [], // [{index: 0, timeLimit: 15}, {index: 1, timeLimit: 15}, ...]
        
        // 기억력 퀴즈/색깔 퀴즈 타입용: 단계별 설정 정보
        memory_stage_count: 3, // 단계 수
        memory_stage_map: [], // MEMORY: [{stage: 1, tileSize: 4, memoryCount: 3, timeLimit: 30, penaltyTime: 5}, ...]
                               // COLOR: [{stage: 1, tileSize: 4, difficulty: 1, timeLimit: 30, penaltyTime: 5}, ...]
        color_difficulty_options: Array.from({ length: 10 }, (_, i) => ({
            label: `난이도 ${i + 1}`,
            value: i + 1
        })),
        
        // 오십까지 퀴즈 타입용: 설정 정보
        fifty_question_count: 50, // 문제 갯수
        fifty_timeLimit: 300, // 전체 게임 시간 (초)
        fifty_penalty_time: 5, // 틀렸을 때 차감 시간 (초)
        
        tile_size_options: [
            { label: '4x4', value: 4 },
            { label: '5x5', value: 5 },
            { label: '6x6', value: 6 },
            { label: '7x7', value: 7 },
            { label: '8x8', value: 8 }
        ],

        selected_quiz_level: [], // 체크된 pid 목록이 여기에 저장됨
        quiz_level_list: [
            { pid: 1, category: '레벨 1' },
            { pid: 2, category: '레벨 2' },
            { pid: 3, category: '레벨 3' },
            { pid: 4, category: '레벨 4' },
            { pid: 5, category: '레벨 5' },
        ] ,
           selectedQuestionIndex: 0, // 현재 선택된 문제 번호 인덱스
            // 문제 총 14개
            questionList: Array.from({ length: 32 }),
            // 카테고리 총 20개
            // categoryList: Array.from({ length: 20 }, (_, i) => ({
            // id: i + 1,
            // label: `${i + 1}번`
            // })),
            //questionCategoryMap: Array.from({ length: 14 }, () => []),

            // quiz_title_text: '',
            // quiz_title_desc_text: '',
            // dialog_title_text: '퀴즈 문제 설정',
   
    }),

    created()
    {    
        this.LoadQuizBundleList();    
    },

    methods:{
        ...mapActions([
            'GET_QUIZ_GROUP_INFO',
            'CREATE_QUIZ_GROUP',
            'GET_QUIZ_GROUP_ITEMINFO',
            'SET_QUIZ_GROUP_ITEMINFO',
        ]),

        LoadQuizBundleList(){   
            //this.loadingData = true;
            // let packageName = this.$store.state.selected_game_package;
            this.loadingData = true;
            this.quizbundle_list_all = [];
            this.GET_QUIZ_GROUP_INFO({}).then((body_data)=>{
                this.loadingData = false; 
                this.category_list = body_data.result.cate.sort((a, b) => {
                  return a.category.localeCompare(b.category, 'ko-KR');
                });

                this.quiz_group_list = body_data.result.group.sort((a, b) => {
                    return a.title.localeCompare(b.title, 'ko-KR');
                });
                console.log("퀴즈 번들리스트를 불러옵니다." + JSON.stringify(  this.quiz_group_list));
                //console.log(JSON.stringify(this.category_list));
                //console.log(JSON.stringify(body_data));
            })
            .catch((err) => {
                this.error = err;
                console.log(err);
            })
        },
        ShowDialog_CreateBundle()
        {
            this.dialog = false;    
            this.dialog2 = true;    
            this.group_title_text = "";
            this.group_comment_text = "";
            this.group_quiz_count = 5;
            this.selected_quiz_type = 'IMG';
        },
        async CreateQuizBundle()
        {
            if(this.group_title_text == "" || this.group_comment_text == "")
            {
                alert("필수요소 작성해주세요 ");
                return;
            }

            this.loadingData = true;
            this.dialog = false;    
            this.dialog2 = false;    
            let title = this.group_title_text;
            let comment = this.group_comment_text;
            let count  = this.group_quiz_count;
            let quiz_type = this.selected_quiz_type;
            let quiz_count = this.group_quiz_count; // 타입에 상관없이 퀴즈 갯수
            this.CREATE_QUIZ_GROUP({title , comment , count, quiz_type, quiz_count}).then((body_data)=>{
                //this.selected_main_item_pid = 0;
                this.LoadQuizBundleList();
            });
                  
        },
        SaveGroupitem() {
            let quiz_items = [];
            let isValid = true;
            let etc_info = null;
            let quiz_count = 0; // 타입에 상관없이 퀴즈 갯수

            // 이미지/타일 퀴즈: 기존 카테고리 선택 방식 (quiz_items 사용)
            if (checkIsCategoryBasedType(this.current_group_type)) {
                quiz_count = this.groupCount;
                for (let order_index = 0; order_index < this.groupCount; order_index++) {
                    const catStates = this.questionCategoryMap[order_index];

                    // 이 문제에 대해 하나라도 enable === true 인 항목이 있는지 확인
                    const hasAtLeastOne = catStates.some(cat => cat.enable);
                    if (!hasAtLeastOne) {
                    alert(`${order_index + 1}번 문제는 하나 이상의 카테고리를 선택해야 합니다.`);
                    isValid = false;
                    break;
                    }

                    // 전송용 데이터 구성 (기존 방식 유지)
                    catStates.forEach((cat) => {
                    quiz_items.push({
                        order_index,
                        ref_quiz_cate_pid: cat.pid,
                        enable: cat.enable ? 'Y' : 'N',
                    });
                    });
                }
                // 이미지/타일 퀴즈는 etc_info를 null로 전송 (백엔드에서 quiz_items로 구분)
                etc_info = null;
            } 
            // 기억력 퀴즈/색깔 퀴즈: etc_info에 단계별 설정 저장
            else if (this.current_group_type === 'MEMORY' || this.current_group_type === 'COLOR') {
                // memory_stage_map이 비어있으면 초기화
                if (!this.memory_stage_map || this.memory_stage_map.length === 0) {
                    if (this.memory_stage_count > 0) {
                        this.updateMemoryStageMap();
                    } else {
                        alert('단계 수를 1 이상으로 설정해주세요.');
                        isValid = false;
                        return;
                    }
                }
                
                // 유효성 검사
                for (let i = 0; i < this.memory_stage_map.length; i++) {
                    const stage = this.memory_stage_map[i];
                    const maxTiles = stage.tileSize * stage.tileSize;
                    
                    if (!stage.tileSize || stage.tileSize < 4 || stage.tileSize > 8) {
                        alert(`${i + 1}단계: 타일 크기는 4x4 ~ 8x8 사이여야 합니다.`);
                        isValid = false;
                        break;
                    }
                    
                    // MEMORY 타입: 기억 타일 수 검증
                    if (this.current_group_type === 'MEMORY') {
                        if (!stage.memoryCount || stage.memoryCount < 1 || stage.memoryCount > maxTiles) {
                            alert(`${i + 1}단계: 기억 타일 수는 1 ~ ${maxTiles} 사이여야 합니다.`);
                            isValid = false;
                            break;
                        }
                    }
                    // COLOR 타입: 난이도 검증
                    else if (this.current_group_type === 'COLOR') {
                        if (!stage.difficulty || stage.difficulty < 1 || stage.difficulty > 10) {
                            alert(`${i + 1}단계: 난이도는 1 ~ 10 사이여야 합니다.`);
                            isValid = false;
                            break;
                        }
                    }
                    
                    if (!stage.timeLimit || stage.timeLimit < 1) {
                        alert(`${i + 1}단계: 퀴즈 풀 시간은 1초 이상이어야 합니다.`);
                        isValid = false;
                        break;
                    }
                    
                    if (stage.penaltyTime < 0) {
                        alert(`${i + 1}단계: 틀렸을 때 감점 시간은 0 이상이어야 합니다.`);
                        isValid = false;
                        break;
                    }
                }
                
                if (!isValid) return;
                
                // 단계별 설정 정보 추출 (객체 배열 형태로 통일)
                // MEMORY: {tileSize, memoryCount, timeLimit, penaltyTime}
                // COLOR: {tileSize, difficulty, timeLimit, penaltyTime}
                const levels = this.memory_stage_map.map(stage => {
                    if (this.current_group_type === 'MEMORY') {
                        return {
                            tileSize: stage.tileSize,
                            memoryCount: stage.memoryCount,
                            timeLimit: stage.timeLimit,
                            penaltyTime: stage.penaltyTime
                        };
                    } else if (this.current_group_type === 'COLOR') {
                        return {
                            tileSize: stage.tileSize,
                            difficulty: stage.difficulty || 1, // 난이도 (1~10)
                            timeLimit: stage.timeLimit,
                            penaltyTime: stage.penaltyTime
                        };
                    }
                    // 기본값 (MEMORY 형태)
                    return {
                        tileSize: stage.tileSize,
                        memoryCount: stage.memoryCount || 1,
                        timeLimit: stage.timeLimit,
                        penaltyTime: stage.penaltyTime
                    };
                });
                
                // etc_info에 저장할 JSON 데이터 구성 (levels로 통일)
                etc_info = {
                    count: this.memory_stage_count,
                    levels: levels
                };

                // quiz_items는 빈 배열로 전달 (MEMORY/COLOR 타입은 etc_info만 사용)
                quiz_items = [];
                quiz_count = this.memory_stage_count;
            }
            // 오십까지 퀴즈: etc_info에 설정 저장
            else if (this.current_group_type === 'FIFTY') {
                // 유효성 검사
                if (!this.fifty_question_count || this.fifty_question_count < 1) {
                    alert('문제 갯수는 1 이상이어야 합니다.');
                    isValid = false;
                    return;
                }
                
                if (!this.fifty_timeLimit || this.fifty_timeLimit < 1) {
                    alert('전체 게임 시간은 1초 이상이어야 합니다.');
                    isValid = false;
                    return;
                }
                
                if (this.fifty_penalty_time < 0) {
                    alert('틀렸을 때 차감 시간은 0 이상이어야 합니다.');
                    isValid = false;
                    return;
                }
                
                if (!isValid) return;
                
                // etc_info에 저장할 JSON 데이터 구성
                etc_info = {
                    count: this.fifty_question_count,
                    timeLimit: this.fifty_timeLimit,
                    penaltyTime: this.fifty_penalty_time
                };

                // quiz_items는 빈 배열로 전달 (FIFTY 타입은 etc_info만 사용)
                quiz_items = [];
                quiz_count = this.fifty_question_count;
            }
            // DRAWING/NONSENSE: 문제 수와 문제별 제한시간 저장
            else if (this.current_group_type === 'DRAWING' || this.current_group_type === 'NONSENSE') {
                // 유효성 검사
                if (!this.groupCount || this.groupCount < 1) {
                    alert('문제 갯수는 1 이상이어야 합니다.');
                    isValid = false;
                    return;
                }
                
                // 문제별 제한시간 유효성 검사
                for (let i = 0; i < this.question_time_map.length; i++) {
                    const timeItem = this.question_time_map[i];
                    if (!timeItem.timeLimit || timeItem.timeLimit < 1) {
                        alert(`${i + 1}번 문제의 제한시간은 1초 이상이어야 합니다.`);
                        isValid = false;
                        break;
                    }
                }
                
                if (!isValid) return;
                
                // 문제별 제한시간 정보 추출
                const timeLimits = this.question_time_map.map(item => ({
                    timeLimit: item.timeLimit || 15
                }));
                
                // etc_info에 저장할 JSON 데이터 구성 (문제 갯수와 제한시간)
                etc_info = {
                    count: this.groupCount,
                    timeLimits: timeLimits
                };

                // quiz_items는 빈 배열로 전달 (DRAWING/NONSENSE 타입은 etc_info만 사용)
                quiz_items = [];
                quiz_count = this.groupCount;
            }
            // 가로세로/4지선답 퀴즈: etc_info 내용을 quiz_items에 넣어서 전달 (백엔드에서 구분 가능하도록)
            else if (checkIsLevelBasedType(this.current_group_type) && this.current_group_type !== 'MEMORY' && this.current_group_type !== 'COLOR' && this.current_group_type !== 'FIFTY' && this.current_group_type !== 'DRAWING' && this.current_group_type !== 'NONSENSE') {
                // 유효성 검사: 문제별 제한시간
                for (let i = 0; i < this.question_level_map.length; i++) {
                    const levelItem = this.question_level_map[i];
                    if (!levelItem.timeLimit || levelItem.timeLimit < 1) {
                        alert(`${i + 1}번 문제의 제한시간은 1초 이상이어야 합니다.`);
                        isValid = false;
                        break;
                    }
                }
                
                if (!isValid) return;
                
                // 레벨 정보 추출 (객체 배열 형태로 통일, 제한시간 포함)
                const levels = this.question_level_map.map(item => ({
                    level: item.level,
                    timeLimit: item.timeLimit || 15
                }));
                
                // etc_info에 저장할 JSON 데이터 구성
                etc_info = {
                    count: this.groupCount,
                    levels: levels
                };

                // etc_info 내용을 quiz_items에 넣어서 전달 (백엔드에서 quiz_items를 확인하여 타입 구분)
                quiz_items = levels;
                quiz_count = this.groupCount;
            }

            if (!isValid) return;

            console.log('📦 전송 데이터 (quiz_items):', JSON.stringify(quiz_items, null, 2));
            console.log('📦 etc_info:', JSON.stringify(etc_info, null, 2));
            console.log('📦 quiz_count:', quiz_count);
            this.CancelEdit();
            this.loadingData = true;
            let group_pid = this.selected_editing_item.pid;

            // etc_info를 JSON 문자열로 변환하여 전송 (null이면 null로 전송)
            const etc_info_str = etc_info ? JSON.stringify(etc_info) : null;
            
            // 저장할 때는 quiz_items 변수를 계속 사용 (백엔드에서 구분하여 저장)
            // quiz_count를 타입에 상관없이 함께 전달
            this.SET_QUIZ_GROUP_ITEMINFO({ group_pid, quiz_items, etc_info: etc_info_str, quiz_count }).then((body_data) => {
                this.loadingData = false;
                this.LoadQuizBundleList();
                alert("저장 완료!");
            });
        },


        handleFileChange(file)
        {
            this.imageFile = file;
        },


     
        OnClickEdit_Item(item) {
            this.loadingData = true;
            this.selected_editing_item = item;
            this.current_group_type = item.quiz_type || 'DEFAULT'; // 그룹 타입 가져오기
            this.dialog = true;
            this.selectedQuestionIndex = 0;

            const group_pid = item.pid;
            console.log("📥 group_pid:", group_pid, "type:", this.current_group_type, "etc_info:", item.etc_info);

            // 🔄 초기화
            this.questionCategoryMap = [];
            this.question_level_map = [];
            this.question_time_map = [];
            this.memory_stage_map = [];
            this.memory_stage_count = 3;
            this.fifty_question_count = 50;
            this.fifty_timeLimit = 300;
            this.fifty_penalty_time = 5;

            // 기억력 퀴즈/색깔 퀴즈: etc_info에서 단계별 설정 정보 로드
            if (this.current_group_type === 'MEMORY' || this.current_group_type === 'COLOR') {
                // 먼저 단계 수를 설정하고 맵 초기화
                this.memory_stage_count = item.count || 3;
                this.updateMemoryStageMap();
                
                if (item.etc_info !== null && item.etc_info !== undefined && item.etc_info !== '') {
                    try {
                        let etcInfo = null;
                        
                        if (typeof item.etc_info === 'object') {
                            etcInfo = item.etc_info;
                        } else if (typeof item.etc_info === 'string') {
                            etcInfo = JSON.parse(item.etc_info);
                        }
                        
                        if (etcInfo && typeof etcInfo === 'object' && !Array.isArray(etcInfo)) {
                            // MEMORY/COLOR 타입의 etc_info 구조: {count: 3, levels: [{tileSize: 4, memoryCount: 3, ...}, ...]}
                            // 하위 호환성: stages도 지원
                            this.memory_stage_count = etcInfo.count || item.count || 3;
                            const levelsData = etcInfo.levels || etcInfo.stages; // levels 우선, 없으면 stages (하위 호환)
                            
                            if (levelsData && Array.isArray(levelsData)) {
                                this.memory_stage_map = levelsData.map((s, idx) => {
                                    // 배열 형태 (하위 호환): [tileSize, memoryCount/difficulty, timeLimit, penaltyTime]
                                    if (Array.isArray(s)) {
                                        if (this.current_group_type === 'COLOR') {
                                            // COLOR: [tileSize, difficulty, timeLimit, penaltyTime]
                                            return {
                                                stage: idx + 1,
                                                tileSize: s[0] || 4,
                                                difficulty: s[1] || 1,
                                                timeLimit: s[2] || 30,
                                                penaltyTime: s[3] || 5
                                            };
                                        } else {
                                            // MEMORY: [tileSize, memoryCount, timeLimit, penaltyTime]
                                            return {
                                                stage: idx + 1,
                                                tileSize: s[0] || 4,
                                                memoryCount: s[1] || 3,
                                                timeLimit: s[2] || 30,
                                                penaltyTime: s[3] || 5
                                            };
                                        }
                                    }
                                    // 객체 형태 (새로운 형식 및 하위 호환)
                                    else if (typeof s === 'object') {
                                        if (this.current_group_type === 'COLOR') {
                                            return {
                                                stage: s.stage || idx + 1,
                                                tileSize: s.tileSize || 4,
                                                difficulty: s.difficulty || s.memoryCount || 1,
                                                timeLimit: s.timeLimit || s.quizTime || 30,
                                                penaltyTime: s.penaltyTime || 5
                                            };
                                        } else {
                                            return {
                                                stage: s.stage || idx + 1,
                                                tileSize: s.tileSize || 4,
                                                memoryCount: s.memoryCount || 3,
                                                timeLimit: s.timeLimit || s.quizTime || 30,
                                                penaltyTime: s.penaltyTime || 5
                                            };
                                        }
                                    }
                                    // 기본값
                                    if (this.current_group_type === 'COLOR') {
                                        return {
                                            stage: idx + 1,
                                            tileSize: 4,
                                            difficulty: 1,
                                            timeLimit: 30,
                                            penaltyTime: 5
                                        };
                                    } else {
                                        return {
                                            stage: idx + 1,
                                            tileSize: 4,
                                            memoryCount: 3,
                                            timeLimit: 30,
                                            penaltyTime: 5
                                        };
                                    }
                                });
                                console.log(`✅ etc_info에서 ${this.current_group_type} 퀴즈 단계 정보 로드 성공:`, this.memory_stage_map);
                            } else {
                                this.updateMemoryStageMap();
                            }
                        } else {
                            this.memory_stage_count = item.count || 3;
                            this.updateMemoryStageMap();
                        }
                    } catch (e) {
                        console.error("etc_info 파싱 실패:", e, "etc_info 값:", item.etc_info);
                        this.memory_stage_count = item.count || 3;
                        this.updateMemoryStageMap();
                    }
                } else {
                    this.memory_stage_count = item.count || 3;
                    this.updateMemoryStageMap();
                }
            }
            // 오십까지 퀴즈: etc_info에서 설정 정보 로드
            else if (this.current_group_type === 'FIFTY') {
                // 기본값 설정
                this.fifty_question_count = item.count || 50;
                this.fifty_timeLimit = 300;
                this.fifty_penalty_time = 5;
                
                if (item.etc_info !== null && item.etc_info !== undefined && item.etc_info !== '') {
                    try {
                        let etcInfo = null;
                        
                        if (typeof item.etc_info === 'object') {
                            etcInfo = item.etc_info;
                        } else if (typeof item.etc_info === 'string') {
                            etcInfo = JSON.parse(item.etc_info);
                        }
                        
                        if (etcInfo && typeof etcInfo === 'object' && !Array.isArray(etcInfo)) {
                            // FIFTY 타입의 etc_info 구조: {count: 50, timeLimit: 300, penaltyTime: 5}
                            this.fifty_question_count = etcInfo.count || item.count || 50;
                            this.fifty_timeLimit = etcInfo.timeLimit || etcInfo.totalTime || 300;
                            this.fifty_penalty_time = etcInfo.penaltyTime || 5;
                            console.log("✅ etc_info에서 오십까지 퀴즈 설정 정보 로드 성공:", {
                                count: this.fifty_question_count,
                                timeLimit: this.fifty_timeLimit,
                                penaltyTime: this.fifty_penalty_time
                            });
                        }
                    } catch (e) {
                        console.error("etc_info 파싱 실패:", e, "etc_info 값:", item.etc_info);
                        this.fifty_question_count = item.count || 50;
                        this.fifty_timeLimit = 300;
                        this.fifty_penalty_time = 5;
                    }
                }
            }
            // DRAWING/NONSENSE: etc_info에서 문제 갯수와 제한시간 로드
            else if (this.current_group_type === 'DRAWING' || this.current_group_type === 'NONSENSE') {
                // 기본값 설정
                this.groupCount = item.count || 5;
                this.question_level_map = []; // 레벨 맵 초기화
                this.updateQuestionTimeMap(); // 문제 수에 맞춰 시간 맵 초기화
                
                if (item.etc_info !== null && item.etc_info !== undefined && item.etc_info !== '') {
                    try {
                        let etcInfo = null;
                        
                        if (typeof item.etc_info === 'object') {
                            etcInfo = item.etc_info;
                        } else if (typeof item.etc_info === 'string') {
                            etcInfo = JSON.parse(item.etc_info);
                        }
                        
                        if (etcInfo && typeof etcInfo === 'object' && !Array.isArray(etcInfo)) {
                            // DRAWING/NONSENSE 타입의 etc_info 구조: {count: 5, timeLimits: [{timeLimit: 15}, ...]}
                            this.groupCount = etcInfo.count || item.count || 5;
                            this.updateQuestionTimeMap(); // 문제 수에 맞춰 시간 맵 초기화
                            
                            // 제한시간 정보가 있으면 로드
                            if (etcInfo.timeLimits && Array.isArray(etcInfo.timeLimits)) {
                                this.question_time_map = etcInfo.timeLimits.map((timeItem, index) => ({
                                    index: index,
                                    timeLimit: timeItem.timeLimit || 15
                                }));
                            }
                            
                            console.log("✅ etc_info에서 그림퀴즈/넌센스 퀴즈 설정 정보 로드 성공:", {
                                count: this.groupCount,
                                timeLimits: this.question_time_map
                            });
                        }
                    } catch (e) {
                        console.error("etc_info 파싱 실패:", e, "etc_info 값:", item.etc_info);
                        this.groupCount = item.count || 5;
                        this.updateQuestionTimeMap();
                    }
                } else {
                    // etc_info가 없으면 기본값으로 초기화
                    this.updateQuestionTimeMap();
                }
            }
            // 가로세로/4지선답 퀴즈: etc_info에서 문제 갯수와 레벨 정보 로드
            else if (checkIsLevelBasedType(this.current_group_type) && this.current_group_type !== 'DRAWING' && this.current_group_type !== 'NONSENSE') {
                // etc_info가 null, undefined, 빈 문자열인 경우 예외처리
                if (item.etc_info !== null && item.etc_info !== undefined && item.etc_info !== '') {
                    try {
                        let etcInfo = null;
                        
                        // etc_info가 이미 객체/배열인 경우 (파싱 불필요)
                        if (typeof item.etc_info === 'object') {
                            etcInfo = item.etc_info;
                        }
                        // etc_info가 문자열인 경우 파싱
                        else if (typeof item.etc_info === 'string') {
                            etcInfo = JSON.parse(item.etc_info);
                        }
                        
                        let levels = null;
                        
                        // etc_info가 배열 형태인 경우 (하위 호환): [2,3,4,2,1] 또는 [{level: 2}, {level: 3}, ...]
                        if (Array.isArray(etcInfo)) {
                            levels = etcInfo;
                            this.groupCount = levels.length > 0 ? levels.length : (item.count || 5);
                        }
                        // etc_info가 객체 형태인 경우: {count: 5, levels: [{level: 2}, {level: 3}, ...]}
                        else if (etcInfo && typeof etcInfo === 'object' && !Array.isArray(etcInfo)) {
                            this.groupCount = etcInfo.count || item.count || 5;
                            levels = etcInfo.levels;
                        }
                        
                        // 레벨 정보가 있으면 로드
                        if (levels && Array.isArray(levels) && levels.length > 0) {
                            this.question_level_map = levels.map((level, index) => {
                                // 객체 형태: {level: 2, timeLimit: 15}
                                if (typeof level === 'object' && level !== null) {
                                    return {
                                        index: index,
                                        level: level.level || 1,
                                        timeLimit: level.timeLimit || 15
                                    };
                                }
                                // 숫자 형태 (하위 호환): 2
                                else {
                                    return {
                                        index: index,
                                        level: level || 1,
                                        timeLimit: 15
                                    };
                                }
                            });
                            console.log("✅ etc_info에서 레벨 정보 로드 성공:", this.question_level_map);
                        } else {
                            // 레벨 정보가 없으면 문제 갯수만큼 기본 레벨 1, 제한시간 15초로 초기화
                            this.groupCount = item.count || 5;
                            this.updateQuestionLevelMap();
                            console.log("⚠️ etc_info에 레벨 정보가 없어 기본값으로 초기화");
                        }
                    } catch (e) {
                        console.error("etc_info 파싱 실패:", e, "etc_info 값:", item.etc_info);
                        this.groupCount = item.count || 5;
                        this.updateQuestionLevelMap();
                    }
                } else {
                    // etc_info가 null, undefined, 빈 문자열이면 기본값으로 초기화
                    console.log("⚠️ etc_info가 없어 기본값으로 초기화 (etc_info:", item.etc_info, ")");
                    this.groupCount = item.count || 5;
                    this.updateQuestionLevelMap();
                }
            } else {
                // 이미지/타일 퀴즈: 기존 방식
                this.groupCount = item.count;
            }

            this.GET_QUIZ_GROUP_ITEMINFO({ group_pid }).then((body_data) => {
                this.loadingData = false;
                this.quiz_group_items = body_data.result;

                // 이미지/타일 퀴즈: 카테고리 정보 로드
                if (checkIsCategoryBasedType(this.current_group_type)) {
                    for (let i = 0; i < this.groupCount; i++) {
                    const groupItems = this.quiz_group_items[i] || [];

                    // ✅ 새로운 배열 생성
                    const categoryStates = this.category_list.map((cat) => {
                        const matched = groupItems.find(item => item.ref_quiz_cate_pid === cat.pid);
                        return {
                        pid: cat.pid,
                        enable: matched?.enable === 'Y'
                        };
                    });

                    // ✅ Vue 반응형 배열로 삽입
                    this.$set(this.questionCategoryMap, i, categoryStates);
                    }

                    // 디버깅 로그 (선택사항)
                    console.log("✅ 초기화된 questionCategoryMap:", JSON.stringify(this.questionCategoryMap, null, 2));
                }
                // 가로세로/4지선답 퀴즈는 etc_info에서 이미 로드했으므로 추가 처리 불필요
            });
        },
        
        // 단계 수 변경 시 기억력 퀴즈 단계 맵 업데이트
        updateMemoryStageMap() {
            const currentLength = this.memory_stage_map.length;
            const newLength = this.memory_stage_count || 0;

            if (newLength === 0) {
                this.memory_stage_map = [];
                return;
            }

            if (newLength > currentLength) {
                // 단계 수가 늘어난 경우: 기본값으로 추가
                for (let i = currentLength; i < newLength; i++) {
                    const defaultStage = {
                        stage: i + 1,
                        tileSize: 4,
                        timeLimit: 30,
                        penaltyTime: 5
                    };
                    // COLOR 타입: difficulty 추가, MEMORY 타입: memoryCount 추가
                    if (this.current_group_type === 'COLOR') {
                        defaultStage.difficulty = 1;
                    } else {
                        defaultStage.memoryCount = 3;
                    }
                    this.memory_stage_map.push(defaultStage);
                }
            } else if (newLength < currentLength) {
                // 단계 수가 줄어든 경우: 배열 자르기
                this.memory_stage_map = this.memory_stage_map.slice(0, newLength);
                // stage 번호 재정렬
                this.memory_stage_map.forEach((stage, idx) => {
                    stage.stage = idx + 1;
                });
            } else if (currentLength === 0 && newLength > 0) {
                // 완전히 빈 배열에서 시작하는 경우: 전체 초기화
                this.memory_stage_map = [];
                for (let i = 0; i < newLength; i++) {
                    const defaultStage = {
                        stage: i + 1,
                        tileSize: 4,
                        timeLimit: 30,
                        penaltyTime: 5
                    };
                    // COLOR 타입: difficulty 추가, MEMORY 타입: memoryCount 추가
                    if (this.current_group_type === 'COLOR') {
                        defaultStage.difficulty = 1;
                    } else {
                        defaultStage.memoryCount = 3;
                    }
                    this.memory_stage_map.push(defaultStage);
                }
            }
        },
        
        // 문제 갯수 변경 시 레벨 맵 업데이트 (DRAWING/NONSENSE는 제외)
        updateQuestionLevelMap() {
            // DRAWING/NONSENSE는 레벨 설정 불필요
            if (this.current_group_type === 'DRAWING' || this.current_group_type === 'NONSENSE') {
                return;
            }

            const currentLength = this.question_level_map.length;
            const newLength = this.groupCount || 0;

            if (newLength === 0) {
                // 문제 수가 0이면 빈 배열로 초기화
                this.question_level_map = [];
                return;
            }

            if (newLength > currentLength) {
                // 문제 수가 늘어난 경우: 기본 레벨 1, 제한시간 15초로 추가
                for (let i = currentLength; i < newLength; i++) {
                    this.question_level_map.push({
                        index: i,
                        level: 1,
                        timeLimit: 15
                    });
                }
            } else if (newLength < currentLength) {
                // 문제 수가 줄어든 경우: 배열 자르기
                this.question_level_map = this.question_level_map.slice(0, newLength);
            } else if (currentLength === 0 && newLength > 0) {
                // 완전히 빈 배열에서 시작하는 경우: 전체 초기화
                this.question_level_map = [];
                for (let i = 0; i < newLength; i++) {
                    this.question_level_map.push({
                        index: i,
                        level: 1,
                        timeLimit: 15
                    });
                }
            }
        },
        
        // DRAWING/NONSENSE 타입: 문제 갯수 변경 시 시간 맵 업데이트
        updateQuestionTimeMap() {
            // DRAWING/NONSENSE가 아니면 함수 종료
            if (this.current_group_type !== 'DRAWING' && this.current_group_type !== 'NONSENSE') {
                return;
            }

            const currentLength = this.question_time_map.length;
            const newLength = this.groupCount || 0;

            if (newLength === 0) {
                // 문제 수가 0이면 빈 배열로 초기화
                this.question_time_map = [];
                return;
            }

            if (newLength > currentLength) {
                // 문제 수가 늘어난 경우: 기본 제한시간 15초로 추가
                for (let i = currentLength; i < newLength; i++) {
                    this.question_time_map.push({
                        index: i,
                        timeLimit: 15
                    });
                }
            } else if (newLength < currentLength) {
                // 문제 수가 줄어든 경우: 배열 자르기
                this.question_time_map = this.question_time_map.slice(0, newLength);
            } else if (currentLength === 0 && newLength > 0) {
                // 완전히 빈 배열에서 시작하는 경우: 전체 초기화
                this.question_time_map = [];
                for (let i = 0; i < newLength; i++) {
                    this.question_time_map.push({
                        index: i,
                        timeLimit: 15
                    });
                }
            }
        },
      
        toggleCategory(orderIndex, cateId) {
            console.log(`✅ 클릭됨: 문제 ${orderIndex}, 카테고리 ${cateId}`);

            const list = this.questionCategoryMap[orderIndex];
            const updated = list.map(item => ({
                ...item,
                enable: item.pid === cateId ? !item.enable : item.enable
            }));
            console.log("🧠 새로운 리스트 : ", updated);
            this.$set(this.questionCategoryMap, orderIndex, updated);
        },
        isCategorySelected(orderIndex, cateId) {
            const list = this.questionCategoryMap[orderIndex] || [];
            return list.find(x => x.pid === cateId)?.enable === true;
        },
        isCategoryEnabled(orderIndex, cateId) {
            const items = this.quiz_group_items?.[orderIndex] || [];
            const found = items.find(x => x.ref_quiz_cate_pid === cateId);
            return found?.enable === 'Y';
        },

        getCategoryColor(orderIndex, cateId) {
            const list = this.questionCategoryMap[orderIndex] || [];
            const item = list.find(x => x.pid === cateId);
            if (!item) return 'grey lighten-2';
            return item.enable ? 'deep-purple accent-4' : 'deep-purple lighten-4';
        },
        // 레벨별 색상 반환
        getLevelColor(level) {
            const colorMap = {
                1: 'green',      // 레벨 1: 초록색
                2: 'orange',     // 레벨 2: 주황색
                3: 'red'         // 레벨 3: 빨간색
            };
            return colorMap[level] || 'grey';
        },
        CancelEdit()
        {
            this.dialog = false;    
            this.dialog2 = false;
            // 초기화
            this.question_time_map = [];
            this.memory_stage_map = [];
            this.memory_stage_count = 3;
            this.fifty_question_count = 50;
            this.fifty_timeLimit = 300;
            this.fifty_penalty_time = 5;
        },
        IsActiveState(_item)
        {
            return _item.active_yn=="Y"?true:false;
        },
        
        // 템플릿에서 사용할 수 있도록 config 함수를 methods에 추가
        isCategoryBasedType(type) {
            return checkIsCategoryBasedType(type);
        },
        
        isLevelBasedType(type) {
            return checkIsLevelBasedType(type);
        },
        
        getQuizTypeLabel(type) {
            return getQuizTypeLabel(type);
        },
        
        getQuizTypeThumbnail(type) {
            return getQuizTypeThumbnail(type);
        },
        
        // 퀴즈 그룹이 초기화되었는지 확인 (활성화 여부 판단)
        // 이미지/타일 퀴즈: quiz_items에 데이터가 있는지 확인
        // 그 외 퀴즈: etc_info에 데이터가 있는지 확인
        getIsInitialized(item) {
            // 이미지/타일 퀴즈는 quiz_items로 판단 (기존 로직 유지)
            if (checkIsCategoryBasedType(item.quiz_type)) {
                // 이미지/타일 퀴즈는 is_enable 필드로 판단
                return item.is_enable === 'Y';
            }
            
            // 그 외 퀴즈 (HV, CHOICE, MEMORY 등)는 etc_info 존재 여부로 판단
            if (item.etc_info !== null && item.etc_info !== undefined && item.etc_info !== '') {
                try {
                    let etcInfo = null;
                    if (typeof item.etc_info === 'object') {
                        etcInfo = item.etc_info;
                    } else if (typeof item.etc_info === 'string') {
                        etcInfo = JSON.parse(item.etc_info);
                    }
                    
                    if (etcInfo && typeof etcInfo === 'object' && !Array.isArray(etcInfo)) {
                        // MEMORY, COLOR 타입: levels 배열이 있고 길이가 0보다 큰지 확인 (하위 호환: stages도 지원)
                        if (item.quiz_type === 'MEMORY' || item.quiz_type === 'COLOR') {
                            const levelsData = etcInfo.levels || etcInfo.stages;
                            return levelsData && Array.isArray(levelsData) && levelsData.length > 0;
                        }
                        // FIFTY 타입: count, timeLimit, penaltyTime이 있는지 확인
                        else if (item.quiz_type === 'FIFTY') {
                            return etcInfo.count && (etcInfo.timeLimit || etcInfo.totalTime) && etcInfo.penaltyTime !== undefined;
                        }
                        // HV, CHOICE 타입: levels 배열이 있고 길이가 0보다 큰지 확인
                        else if (item.quiz_type === 'HV' || item.quiz_type === 'CHOICE') {
                            return etcInfo.levels && Array.isArray(etcInfo.levels) && etcInfo.levels.length > 0;
                        }
                        // 기타 타입도 etc_info가 있으면 초기화된 것으로 간주
                        return true;
                    }
                    // 배열 형태의 etc_info도 초기화된 것으로 간주
                    if (Array.isArray(etcInfo) && etcInfo.length > 0) {
                        return true;
                    }
                } catch (e) {
                    console.error("etc_info 파싱 실패:", e);
                    return false;
                }
            }
            
            return false;
        },
        
        // 타일 크기별 난이도 색상 반환
        getTileSizeColor(tileSize) {
            const colorMap = {
                4: 'green',      // 4x4: 쉬움 (초록색)
                5: 'light-blue', // 5x5: 보통 (하늘색)
                6: 'orange',     // 6x6: 어려움 (주황색)
                7: 'red',        // 7x7: 매우 어려움 (빨간색)
                8: 'purple darken-2' // 8x8: 최고 난이도 (보라색)
            };
            return colorMap[tileSize] || 'grey';
        },
        
        // 타일 크기별 난이도 텍스트 반환
        getTileSizeDifficulty(tileSize) {
            const difficultyMap = {
                4: '쉬움',
                5: '보통',
                6: '어려움',
                7: '매우 어려움',
                8: '최고 난이도'
            };
            return difficultyMap[tileSize] || '미설정';
        },
        
        // 타일 크기별 아이콘 반환
        getTileSizeIcon(tileSize) {
            const iconMap = {
                4: 'mdi-emoticon-happy',
                5: 'mdi-emoticon-neutral',
                6: 'mdi-emoticon-sad',
                7: 'mdi-emoticon-dead',
                8: 'mdi-skull'
            };
            return iconMap[tileSize] || 'mdi-help-circle';
        },
  
    },
    computed: {
        isLive(){
            return config.isLive;
        },
        noticeStartDate () {
            return `${this.date} ${this.time1}`
        },
        noticeEndDate () {
            return `${this.date2} ${this.time2}`
        },
    },
    components:{
    },
    watch :{
            //'$store.state.selected_game_package': function() {
            //console.log("WHAT IS THIS? " + this.$store.state.selected_game_package)
            //this.LoadServerInfo();
        //},
          selectedQuestionIndex(val) {
            console.log(`🔁 문제 ${val + 1}번으로 이동`);
            console.log("🧠 현재 상태:", JSON.stringify(this.questionCategoryMap[val]));
        }
    }
};
</script>
